/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Driver_Remittance_Self_ReceiveInputs */

const vi_error_driver_remittance_self_receive = /** @type {(inputs: Error_Driver_Remittance_Self_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không thể tự nhận tiền của chính mình.`)
};

/**

* @param {Error_Driver_Remittance_Self_ReceiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_driver_remittance_self_receive = /** @type {((inputs?: Error_Driver_Remittance_Self_ReceiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Driver_Remittance_Self_ReceiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_driver_remittance_self_receive(inputs)
});